export const loginApi = async (email: string, password: string) => {
  const res = await fetch(`https://admin-talentlink.digiline.id/api/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ email, password }),
  });

  if (!res.ok) throw new Error("Login failed");

  return res.json();
};

export const forgotPasswordApi = async (email: string) => {
  const res = await fetch(
    `https://admin-talentlink.digiline.id/api/forgot-password`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    }
  );

  const data = await res.json();

  if (!res.ok) {
    throw data; // ⬅️ lempar object error API
  }

  return data;
};
